export default __webpack_public_path__ + "static/media/local_moviestheaters.1f5e2b3a.svg";